export default __webpack_public_path__ + "static/media/Me.28086406.jpg";